import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { BillingFormComponent } from './layouts/billing-form/billing-form.component';
import { UserBackOfficeComponent } from './layouts/user-backoffice/user-backoffice.component';
import { FullComponent } from './layouts/full/full.component';

const routes: Routes = [
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        redirectTo: '/page/home',
        pathMatch: 'full',
      },
      {
        path: 'page',
        loadChildren: () =>
          import('./pages/page/page.module').then(
            (m) => m.PageModule
          ),
      },
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'course',
        loadChildren: () =>
          import('./pages/course/course.module').then(
            (m) => m.CourseModule
          ),
      },
    ],
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/user/course',
        pathMatch: 'full',
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./pages/user/user.module').then(
            (m) => m.UserModule
          ),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./pages/admin/admin.module').then(
            (m) => m.AdminModule
          ),
      },
      {
        path: 'contractor',
        loadChildren: () =>
          import('./pages/contractor/contractor.module').then(
            (m) => m.ContractorModule
          ),
      },
     
      {
        path: 'request',
        loadChildren: () =>
          import('./pages/request/request.module').then(
            (m) => m.RequestModule
          ),
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./pages/report/report.module').then(
            (m) => m.ReportModule
          ),
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./pages/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./pages/ui-components/ui-components.module').then(
            (m) => m.UicomponentsModule
          ),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./pages/forms/forms.module').then((m) => m.FormModule),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./pages/charts/charts.module').then((m) => m.ChartsModule),
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./pages/apps/apps.module').then((m) => m.AppsModule),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./pages/widgets/widgets.module').then((m) => m.WidgetsModule),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/tables/tables.module').then((m) => m.TablesModule),
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./pages/theme-pages/theme-pages.module').then(
            (m) => m.ThemePagesModule
          ),
      },
      {
        path: 'setting',
        loadChildren: () =>
          import('./pages/setting/setting.module').then(
            (m) => m.SettingModule
          ),
      }
    ],
  },
  {
    path: '',
    component: BillingFormComponent,
    children: [
      {
        path: 'preview',
        loadChildren: () =>
          import('./preview/preview.module').then((m) => m.PreviewModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
